(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/overview-top-positions.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/overview-top-positions.js');
"use strict";


const Sausage = svs.ui.reactSausage;
const rotationStart = start => ({
  transform: "rotate(".concat(start * 3.6, "deg)")
});
const TopPositionsDiagram = _ref => {
  let {
    data
  } = _ref;
  const firstPlaces = data.totalFirstPlaces ? data.totalFirstPlaces : 0;
  const secondPlaces = data.totalSecondPlaces ? data.totalSecondPlaces : 0;
  const thirdPlaces = data.totalThirdPlaces ? data.totalThirdPlaces : 0;
  const secondThirdPlaces = thirdPlaces + secondPlaces;
  const totRaces = data.totalRaces ? data.totalRaces : 0;
  const othersPlaces = totRaces - (secondThirdPlaces + firstPlaces);
  const getPercent = (part, through) => through !== 0 ? Math.round(part / through * 100) : 0;
  const firstPercent = getPercent(firstPlaces, totRaces);
  const secondThirdPercent = getPercent(secondPlaces + thirdPlaces, totRaces);
  let othersPercent = getPercent(othersPlaces, totRaces);
  const sumPercent = firstPercent + secondThirdPercent + othersPercent;

  othersPercent = sumPercent <= 100 ? othersPercent + (100 - sumPercent) : othersPercent;
  const percentage = [{
    start: 0,
    duration: firstPercent,
    color: '#c7e9e3',
    center: Math.round(firstPercent + secondThirdPercent) !== 0 ? Math.round(firstPercent + secondThirdPercent) : '0'
  }, {
    start: firstPercent,
    duration: secondThirdPercent,
    color: '#00a88b'
  }, {
    start: firstPercent + secondThirdPercent,
    duration: othersPercent,
    color: '#004a3d'
  }];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "overview-circle-diagram-holder"
  }, percentage.map(diagram => React.createElement("div", {
    className: "overview-circle-diagram",
    key: diagram.color
  }, React.createElement(Sausage, {
    animate: true,
    className: "sausage-custom",
    color: diagram.color,
    percent: diagram.duration,
    sharpEdges: true,
    strokeWidth: "8",
    style: rotationStart(diagram.start)
  }, diagram.center && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "fc-racing-900"
  }, "Topp 3"), React.createElement("span", null, diagram.center, ' ', "%")))))), React.createElement("div", {
    className: "overview-cicrle-color-desc"
  }, React.createElement("li", {
    className: "first-place color-desc-item"
  }, React.createElement("div", {
    className: "rectangle"
  }), React.createElement("span", {
    className: "label fc-racing-900"
  }, "Vinnare"), React.createElement("span", {
    className: "value f-bold"
  }, firstPlaces)), React.createElement("li", {
    className: "second-and-third-places color-desc-item"
  }, React.createElement("div", {
    className: "rectangle"
  }), React.createElement("span", {
    className: "label fc-racing-900"
  }, "2:a & 3:e plats"), React.createElement("span", {
    className: "value f-bold"
  }, secondThirdPlaces)), React.createElement("li", {
    className: "other-places color-desc-item"
  }, React.createElement("div", {
    className: "rectangle"
  }), React.createElement("span", {
    className: "label fc-racing-900"
  }, "\xD6vriga"), React.createElement("span", {
    className: "value f-bold"
  }, othersPlaces))));
};
svs.racing_game.components.statistics.TopPositionsDiagram = TopPositionsDiagram;

 })(window);